import module from 'guest/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('guest', {
    url: '/guest/{usuario}',
    resolve: {
      auth: (Permisos, $session, $stateParams) => {
        return Permisos.validar(() => {
          return $session.isAdmin()
            || $session.isDeveloper()
            || ($session.isGuest() && $session.username() === $stateParams.usuario)
        })
      },
      usuario: ($stateParams) => $stateParams['usuario'],
      idProyecto: ($stateParams) => $stateParams['usuario'].split('@')[1],
      idColaborador: ($stateParams) => $stateParams['usuario'].split('@')[0],
      data: (auth, Guest, idProyecto, idColaborador) => Guest.get(idProyecto, idColaborador)
        .then((response) => response.data),
      catalogos: ($catalogos) => $catalogos.$fetch(),
    },
    data: {
      title: '{{data.Nombre}} {{data.Apellido_Paterno}} {{data.Apellido_Materno}}',
    },
    template: '<guest id-empresa="idProyecto" id-empleado="idColaborador" data="data" catalogos="catalogos"></guest>',
    controller: ($scope, idProyecto, idColaborador, data, catalogos) => {
      $scope.idProyecto = idProyecto
      $scope.idColaborador = idColaborador
      $scope.data = data
      $scope.catalogos = catalogos
    },
  })
})



// WEBPACK FOOTER //
// ./src/guest/routes/guest.js